import { handleService } from './common'

export default {
  // 查询固件版本
  GetVersionTable (data) {
    let url = '/api/Version/GetListByPage'
    return handleService(url, data)
  },

  // 推送固件
  UpdateVersion (data) {
    let url = '/api/Device/PushVersion'
    return handleService(url, data, 'POST')
  },

  // 批量重启
  RebootDevices (data) {
    let url = '/api/Device/RebootDevice'
    return handleService(url, data, 'POST')
  }
}
